"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueSubscriptionComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var main_1 = require("../../../../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var react_2 = require("react");
var react_3 = require("@iconify/react");
var subscription_dropdown_1 = require("../../../../../components/form/subscription-dropdown");
var subscriptions_1 = require("../../../../../api/subscriptions");
var IssueSubscriptionComponent = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var customer = (0, react_redux_1.useSelector)(function (state) { return state.customerState; }).customer;
    var _a = (0, react_2.useState)(""), selectedSubscriptionId = _a[0], setSelectedSubscriptionId = _a[1];
    var _b = (0, subscriptions_1.useIssueSubscriptionMutation)(), issueSubscription = _b[0], isLoading = _b[1].isLoading;
    var _issueSubscription = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1, message;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, issueSubscription({ user_id: customer === null || customer === void 0 ? void 0 : customer._id, subscription_id: selectedSubscriptionId }).unwrap()];
                case 1:
                    response = _c.sent();
                    dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [(_a = response === null || response === void 0 ? void 0 : response.message) !== null && _a !== void 0 ? _a : "The subscription was issued."] }));
                    dispatch((0, main_1.setContentModal)(null));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    message = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.error) !== null && _b !== void 0 ? _b : "The subscription could not be issued.";
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when issuing a subscription.", messages: [message] }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1 lg:gap-2 lg:h-full md:h-auto sm:h-auto", children: [(0, jsx_runtime_1.jsx)(subscription_dropdown_1.SubscriptionDropdown, { label: "Select a subscription...", selectedIds: selectedSubscriptionId ? [selectedSubscriptionId] : [], onSelectionChange: function (ids) { var _a; return setSelectedSubscriptionId((_a = ids[0]) !== null && _a !== void 0 ? _a : ""); } }), (0, jsx_runtime_1.jsx)("hr", {}), (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between items-center gap-2", children: [(0, jsx_runtime_1.jsxs)(react_1.Button, { variant: "secondary", size: "sm", onPress: function () { return dispatch((0, main_1.setContentModal)(null)); }, children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:cancel" }), "Cancel"] }), (0, jsx_runtime_1.jsxs)(react_1.Button, { size: "sm", variant: "primary", isDisabled: !selectedSubscriptionId, isPending: isLoading, onPress: _issueSubscription, children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:content-save" }), "Issue"] })] })] }));
};
exports.IssueSubscriptionComponent = IssueSubscriptionComponent;
